import styled from "styled-components";

const SwipeDiv = styled.div`
  display: flex;
  flex: 1;
`;

export default SwipeDiv;
